import api from "./api";
import { RSVP, RSVPFormData } from "../types";

export const rsvpService = {
  // Submit RSVP (no eventId needed)
  submitRSVP: async (data: RSVPFormData): Promise<RSVP> => {
    const response = await api.post("/rsvp", data);
    return response.data.data;
  },

  // Update RSVP by email (no eventId needed)
  updateRSVP: async (data: RSVPFormData & { email: string }): Promise<RSVP> => {
    const response = await api.put("/rsvp", data);
    return response.data.data;
  },

  // Get RSVP by email (no eventId needed)
  getRSVP: async (email: string): Promise<RSVP> => {
    const response = await api.get(`/rsvp/${email}`);
    return response.data.data;
  },

  // Get RSVP by ID (admin only)
  getRSVPById: async (id: string): Promise<RSVP> => {
    const response = await api.get(`/rsvp/id/${id}`);
    return response.data.data;
  },

  // Get all RSVPs (admin only)
  getAllRSVPs: async (params?: {
    page?: number;
    limit?: number;
    attendance?: string;
  }): Promise<{
    rsvps: RSVP[];
    pagination: {
      current: number;
      pages: number;
      total: number;
    };
  }> => {
    const response = await api.get("/rsvp", { params });
    return response.data.data;
  },

  // Delete RSVP (admin only)
  deleteRSVP: async (id: string): Promise<void> => {
    await api.delete(`/rsvp/${id}`);
  },
};
